export default {
  title: 'Offre en chevauchement sur la même période',
  buttons: {
    save_as_active: 'Définir comme nouvelle offre active',
    save_as_inactive: 'Enregistrer comme inactive',
    cancel: 'Annuler',
  },
  description: {
    base: "{{offer}} chevauche l'offre active {{overlappingOffer}} le {{weekday}}{{between}}. Une seule offre peut être active sur la même période.",
    between: ', entre {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Comment résoudre : choisissez une option ci-dessous.',
  },
};
